import { render } from "./MigrateVMStorage.vue?vue&type=template&id=ec23346e&scoped=true"
import script from "./MigrateVMStorage.vue?vue&type=script&lang=js"
export * from "./MigrateVMStorage.vue?vue&type=script&lang=js"

import "./MigrateVMStorage.vue?vue&type=style&index=0&id=ec23346e&scoped=true&lang=less"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec23346e"]])

export default __exports__